export default {
  async bills(config = {}) {
    return await this.$post({
      url: `${this.$baseurl}/admin/transactions/refundable/bills/processed`,
      headers: this.headers,
      ...config,
    });
  },
  async transfers(config = {}) {
    return await this.$post({
      url: `${this.$baseurl}/admin/transactions/refundable/transfers/processed`,
      headers: this.headers,
      ...config,
    });
  },
};
